/*
 * Olavson: Closed Shop (Private Sale 15.11.2026), Logik der Passwortmaske. Stand 19.10.2026.
 * Entscheidung beim Laden: snippets/olv-closed-shop-head.liquid (window.__olvCS). Markup: sections/olv-closed-shop.liquid.
 *
 *  - Serverzeit: Date-Header von /cart.js (nie gecacht), Abstand zur Browseruhr in window.__olvSrvSkew (gemeinsam mit
 *    Gift-Watcher und olv-tier-bar.js) und fuer die naechste Seite in sessionStorage olv_srv_skew. Danach wird neu
 *    entschieden: eine falsch gehende Browseruhr sperrt oder oeffnet also hoechstens bis zur ersten Antwort.
 *  - Fensterwechsel bei offener Seite: Timer auf die naechste Grenze, dort frische Serverzeit und neu entscheiden.
 *    Zusaetzlich beim Zurueckkehren in den Tab (Timer schlafen in Hintergrund-Tabs).
 *  - Freischaltung: Cookie olv_cs=<from>-<to> mit path=/ bis Fensterende. Gilt damit auf allen Seiten und in allen
 *    Markt-Subfoldern und nur fuer genau dieses Fenster. Technisch notwendig, also ohne Einwilligung zulaessig.
 *    In der Vorschau (?closed_preview=1, Theme-Editor) kein Cookie, die Maske oeffnet nur fuer diese Seite.
 *  - Barrierefreiheit: Hintergrund inert (auch spaeter eingefuegte Elemente, z. B. Drawer), Fokus ins Feld,
 *    Enter schickt ab, Fehler per aria-live.
 *  - Fallstrick: Fehlt die Maske im DOM oder crypto.subtle (nur ohne HTTPS), oeffnet sich der Shop. Lieber offen als
 *    fuer alle gesperrt.
 */
(function () {
  var C = window.__olvCS;
  if (!C || C.init) return;
  C.init = true;

  var d = document.documentElement;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEEP = ['shopify-section-olv-closed-shop', 'usercentrics-cmp-ui', 'usercentrics-root'];
  var host, form, input, errEl, btn, cdEl, cdOut, cfg = { h: [] }, mo = null, boundTimer = null, cdTimer = null;

  function locked() { return d.classList.contains('olv-cs-lock'); }

  /* ---------- Serverzeit ---------- */
  function noteSrv(r) {
    try {
      var t = Date.parse(r.headers.get('Date'));
      if (!isNaN(t)) {
        window.__olvSrvSkew = t - Date.now();
        try { sessionStorage.setItem('olv_srv_skew', String(window.__olvSrvSkew)); } catch (e) {}
      }
    } catch (e) {}
    return r;
  }
  function syncSrv() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(noteSrv).catch(function () {});
  }

  /* ---------- Sperren / Oeffnen ---------- */
  function inertAll(on) {
    var kids = document.body ? document.body.children : [];
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (KEEP.indexOf(el.id) >= 0 || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
      if (on) { if (!el.inert) { el.inert = true; el.setAttribute('data-olv-cs-inert', ''); } }
      else if (el.hasAttribute('data-olv-cs-inert')) { el.inert = false; el.removeAttribute('data-olv-cs-inert'); }
    }
  }
  function apply(lock) {
    var was = locked();
    d.classList.toggle('olv-cs-lock', lock);
    inertAll(lock);
    if (lock) {
      if (!mo && window.MutationObserver) {
        mo = new MutationObserver(function () { if (locked()) inertAll(true); });
        mo.observe(document.body, { childList: true });
      }
      if (!was || document.activeElement !== input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
      startCountdown();
    } else {
      if (mo) { mo.disconnect(); mo = null; }
      stopCountdown();
    }
  }
  function evaluate() {
    apply(C.decide());
    scheduleBoundary();
  }
  function scheduleBoundary() {
    if (boundTimer) { clearTimeout(boundTimer); boundTimer = null; }
    if (C.preview || C.open) return;
    var now = C.now(), next = null;
    C.w.forEach(function (w) { [w.from, w.to].forEach(function (b) { if (b != null && b > now && (next === null || b < next)) next = b; }); });
    if (next === null) return;
    var ms = (next - now) * 1000 + 1000;
    if (ms < 2147000000) boundTimer = setTimeout(function () { boundTimer = null; syncSrv().then(evaluate); }, ms);
  }

  /* ---------- Countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = cfg.cdTo - C.now();
    if (left <= 0) { stopCountdown(); cdEl.hidden = true; return; }
    var dd = Math.floor(left / 86400), hh = Math.floor(left % 86400 / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
    cdOut.textContent = (dd ? dd + ' T ' : '') + pad(hh) + ':' + pad(mm) + ':' + pad(ss);
    cdEl.hidden = false;
  }
  function startCountdown() { if (!cdEl || cdTimer || !cfg.cdTo) return; tick(); cdTimer = setInterval(tick, 1000); }
  function stopCountdown() { if (cdTimer) { clearInterval(cdTimer); cdTimer = null; } }

  /* ---------- Passwort ---------- */
  function hex(buf) {
    var b = new Uint8Array(buf), s = '';
    for (var i = 0; i < b.length; i++) s += (b[i] < 16 ? '0' : '') + b[i].toString(16);
    return s;
  }
  function showError(msg) {
    errEl.textContent = '';
    /* Neu setzen nach kurzer Pause, damit Screenreader dieselbe Meldung erneut vorlesen */
    setTimeout(function () { errEl.textContent = msg; }, 30);
    input.setAttribute('aria-invalid', 'true');
    input.select();
  }
  function unlock() {
    var w = C.active(C.now());
    if (w) {
      /* Im laufenden Fenster immer merken, auch mit ?closed_preview=1 (22.10.2026). Cookie und zusaetzlich localStorage. */
      var ms = (w.to - C.now()) * 1000;
      document.cookie = 'olv_cs=' + C.sig(w) + '; path=/; expires=' + new Date(Date.now() + ms).toUTCString() + '; SameSite=Lax; Secure';
      try { localStorage.setItem('olv_cs', C.sig(w)); } catch (e) {}
    } else {
      C.open = true; /* reine Vorschau ausserhalb eines Fensters: nur fuer diese Seite */
    }
    input.value = '';
    input.removeAttribute('aria-invalid');
    errEl.textContent = '';
    evaluate();
    if (!locked()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'closed_shop_unlock', closed_shop_window: w ? C.sig(w) : 'preview', page_path: location.pathname });
      /* 22.10.2026: Startseite (auch /nl-nl usw.) -> Ziel aus der Section, Query (UTM) geht mit. Alle anderen Seiten bleiben. */
      if (cfg.home && C.norm(location.pathname) === '/') {
        var target = /^https?:\/\//i.test(cfg.home) ? cfg.home : ROOT.replace(/\/$/, '') + '/' + cfg.home.replace(/^\//, '');
        location.assign(target + (target.indexOf('?') >= 0 ? location.search.replace(/^\?/, '&') : location.search));
        return;
      }
      var main = document.getElementById('main');
      if (main) { main.setAttribute('tabindex', '-1'); try { main.focus({ preventScroll: true }); } catch (e) {} }
    }
  }
  function onSubmit(e) {
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    /* 22.10.2026: ALLE Leerzeichen entfernen, nicht nur aussen: „Insider 26“, „INSIDER26“, „insider26“ gelten gleich */
    var v = String(input.value || '').replace(/\s+/g, '').toLowerCase();
    /* NFC: zerlegte Umlaute (u + Trema, kommt aus manchen Tastaturen und Copy-Paste) wie die Liquid-Seite behandeln */
    if (v.normalize) v = v.normalize('NFC');
    if (!v) { showError(cfg.empty || ''); return; }
    if (!(window.crypto && crypto.subtle && window.TextEncoder)) { console.warn('[Closed Shop] crypto.subtle fehlt, Shop wird geoeffnet.'); unlock(); return; }
    btn.setAttribute('aria-busy', 'true');
    crypto.subtle.digest('SHA-256', new TextEncoder().encode(v)).then(function (buf) {
      if (cfg.h.indexOf(hex(buf)) >= 0) unlock(); else showError(cfg.error || '');
    }).catch(function () { showError(cfg.error || ''); }).then(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ---------- Start ---------- */
  function init() {
    host = document.querySelector('[data-olv-cs]');
    form = host && host.querySelector('[data-olv-cs-form]');
    if (!form) {
      if (locked()) console.error('[Closed Shop] Maske fehlt im DOM, Shop wird geoeffnet.');
      d.classList.remove('olv-cs-lock');
      return;
    }
    try { cfg = JSON.parse(document.querySelector('[data-olv-cs-config]').textContent) || cfg; } catch (e) {}
    cfg.h = cfg.h || [];
    input = form.querySelector('input');
    btn = form.querySelector('[type="submit"]');
    errEl = form.querySelector('[data-olv-cs-error]');
    cdEl = host.querySelector('[data-olv-cs-countdown]');
    cdOut = cdEl && cdEl.querySelector('[data-olv-cs-cd]');
    form.addEventListener('submit', onSubmit);
    input.addEventListener('input', function () { if (input.hasAttribute('aria-invalid')) { input.removeAttribute('aria-invalid'); errEl.textContent = ''; } });

    evaluate();
    syncSrv().then(evaluate);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') syncSrv().then(evaluate); });
    /* Zurueck-Button aus dem bfcache: Cookie kann inzwischen gesetzt oder abgelaufen sein */
    window.addEventListener('pageshow', function (e) { if (e.persisted) evaluate(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
